import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  position: relative;
`;

export const Select = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  padding: 8px 16px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.blueLight : theme.colors.grey100};
  border: 1px solid
    ${({ isSelected, theme }) => (isSelected ? theme.colors.blueMain : theme.colors.grey005)};
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const Text = styled(typography.BodyTextOneRegularTypography)`
  margin: 0 8px;
  white-space: nowrap; /* Prevent text from wrapping */
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.black};
`;

export const Icon = styled.div`
  &:before {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    font-size: 12px;
    margin: ${({ margin }) => margin};
  }
`;

export const Envelop = styled.div`
  width: 200px;
  max-height: 230px;
  background-color: white;
  box-sizing: border-box;
  overflow-y: auto;
`;

export const EnvelopItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

export const EnvelopWrapper = styled.div`
  position: absolute;
  right: 0;
  left: unset;
  width: 200px;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 2;
`;

export const TextInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  align-items: center;
  background-color: rgb(241, 244, 246);
  border-radius: 4px;
  width: 100%;
`;

export const TextInput = styled.input`
  height: 36px;
  font-size: 13px;
  line-height: 20px;
  color: rgb(126, 126, 126);
  background-color: rgb(241, 244, 246);
  border: none;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
`;

export const EmptyStateText = styled(typography.BodyTextOneRegularTypography)`
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
`;

export const extendLoaderStyle = css`
  height: 16px;
  width: 16px;
  border: 1px solid #f3f3f3;
  border-top: 3px solid #3498db;
  margin: 0;
`;
